export default "__VITE_ASSET__tZXmmn4T__"